"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.FacilityInterestCreateDtoFormVersionEnum = void 0;
exports.instanceOfFacilityInterestCreateDto = instanceOfFacilityInterestCreateDto;
exports.FacilityInterestCreateDtoFromJSON = FacilityInterestCreateDtoFromJSON;
exports.FacilityInterestCreateDtoFromJSONTyped = FacilityInterestCreateDtoFromJSONTyped;
exports.FacilityInterestCreateDtoToJSON = FacilityInterestCreateDtoToJSON;
exports.FacilityInterestCreateDtoToJSONTyped = FacilityInterestCreateDtoToJSONTyped;
const InterestWorkType_1 = require("./InterestWorkType");
const TravelWillingness_1 = require("./TravelWillingness");
const ContactPreference_1 = require("./ContactPreference");
const InterestShiftLength_1 = require("./InterestShiftLength");
const InterestAvailability_1 = require("./InterestAvailability");
const InterestShiftType_1 = require("./InterestShiftType");
const WorkTypePreference_1 = require("./WorkTypePreference");
/**
 * @export
 */
exports.FacilityInterestCreateDtoFormVersionEnum = {
    NUMBER_1: 1,
    NUMBER_2: 2
};
/**
 * Check if a given object implements the FacilityInterestCreateDto interface.
 */
function instanceOfFacilityInterestCreateDto(value) {
    if (!('facilityId' in value) || value['facilityId'] === undefined)
        return false;
    if (!('nurseProfileId' in value) || value['nurseProfileId'] === undefined)
        return false;
    if (!('specialtyCodes' in value) || value['specialtyCodes'] === undefined)
        return false;
    return true;
}
function FacilityInterestCreateDtoFromJSON(json) {
    return FacilityInterestCreateDtoFromJSONTyped(json, false);
}
function FacilityInterestCreateDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'facilityId': json['facilityId'],
        'nurseProfileId': json['nurseProfileId'],
        'formVersion': json['formVersion'] == null ? undefined : json['formVersion'],
        'workTypePreference': json['workTypePreference'] == null ? undefined : (0, WorkTypePreference_1.WorkTypePreferenceFromJSON)(json['workTypePreference']),
        'willingToTravel': json['willingToTravel'] == null ? undefined : (0, TravelWillingness_1.TravelWillingnessFromJSON)(json['willingToTravel']),
        'specialtyCodes': json['specialtyCodes'],
        'comment': json['comment'] == null ? undefined : json['comment'],
        'startDateComment': json['startDateComment'] == null ? undefined : json['startDateComment'],
        'workTypes': json['workTypes'] == null ? undefined : (json['workTypes'].map(InterestWorkType_1.InterestWorkTypeFromJSON)),
        'workTypeOther': json['workTypeOther'] == null ? undefined : json['workTypeOther'],
        'shiftTypes': json['shiftTypes'] == null ? undefined : (json['shiftTypes'].map(InterestShiftType_1.InterestShiftTypeFromJSON)),
        'shiftTypeOther': json['shiftTypeOther'] == null ? undefined : json['shiftTypeOther'],
        'shiftLengths': json['shiftLengths'] == null ? undefined : (json['shiftLengths'].map(InterestShiftLength_1.InterestShiftLengthFromJSON)),
        'availability': json['availability'] == null ? undefined : (0, InterestAvailability_1.InterestAvailabilityFromJSON)(json['availability']),
        'availabilityOther': json['availabilityOther'] == null ? undefined : json['availabilityOther'],
        'minimumRate': json['minimumRate'] == null ? undefined : json['minimumRate'],
        'contactPreference': json['contactPreference'] == null ? undefined : (0, ContactPreference_1.ContactPreferenceFromJSON)(json['contactPreference']),
    };
}
function FacilityInterestCreateDtoToJSON(json) {
    return FacilityInterestCreateDtoToJSONTyped(json, false);
}
function FacilityInterestCreateDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'facilityId': value['facilityId'],
        'nurseProfileId': value['nurseProfileId'],
        'formVersion': value['formVersion'],
        'workTypePreference': (0, WorkTypePreference_1.WorkTypePreferenceToJSON)(value['workTypePreference']),
        'willingToTravel': (0, TravelWillingness_1.TravelWillingnessToJSON)(value['willingToTravel']),
        'specialtyCodes': value['specialtyCodes'],
        'comment': value['comment'],
        'startDateComment': value['startDateComment'],
        'workTypes': value['workTypes'] == null ? undefined : (value['workTypes'].map(InterestWorkType_1.InterestWorkTypeToJSON)),
        'workTypeOther': value['workTypeOther'],
        'shiftTypes': value['shiftTypes'] == null ? undefined : (value['shiftTypes'].map(InterestShiftType_1.InterestShiftTypeToJSON)),
        'shiftTypeOther': value['shiftTypeOther'],
        'shiftLengths': value['shiftLengths'] == null ? undefined : (value['shiftLengths'].map(InterestShiftLength_1.InterestShiftLengthToJSON)),
        'availability': (0, InterestAvailability_1.InterestAvailabilityToJSON)(value['availability']),
        'availabilityOther': value['availabilityOther'],
        'minimumRate': value['minimumRate'],
        'contactPreference': (0, ContactPreference_1.ContactPreferenceToJSON)(value['contactPreference']),
    };
}
//# sourceMappingURL=FacilityInterestCreateDto.js.map